// Single source of truth for brand, agent, brokerage, and contact details.
// Edit this file to update info site-wide.

export const BRAND = {
  name: "Irving Real Estate Group",
  tagline: "The Irving Experience. It Will Move You!",
  shortName: "IREG",
  logo: "/logo-new.png",
  assistant: "Jason",
  primaryColor: "#15233a",
  goldColor: "#d4af37",
  domain: "irvingrealestategroup.com",
};

export const AGENT = {
  name: "Torey Irving",
  title: "Realtor & Broker",
  licenseNumber: "0593548",
  licenseState: "Texas",
  photo: "/torey.jpg",
  email: "torey@irvingrealestategroup.com", // update if you prefer a different email
  phone: "817-308-0922",
  yearsLicensed: "Licensed Texas Realtor since 2008",
  cityResidence: "Fort Worth, TX",
  bio: `Torey has been in the mortgage banking industry for nearly 15 years. He first started as a real estate coordinator and that sparked his interest in being a realtor. He first received his Texas Realtor License in 2008. Torey loves meeting new people, educating them on the market and getting his clients into their forever home. His client dedication and love of helping others are what motivate him most. He possesses a relentless work ethic and exceptional listening skills.

As a resident of Fort Worth, TX, Torey loves spending time with his 4 children. He prides himself on being honest, trustworthy, and knowledgeable in the real estate market. He knows how important it is to find your dream home or get the best offer for your property. Therefore he will make it his responsibility to help you achieve those goals.

Whether you're buying a home or selling, let Torey apply for the job of being your Real Estate Expert!`,
};

export const BROKERAGE = {
  name: "Irving Real Estate Group",
  licenseNumber: "9008825",
  licenseType: "Texas Real Estate Brokerage",
  office: {
    street: "600 W 6th Street, Suite 400",
    city: "Fort Worth",
    state: "TX",
    zip: "76102",
    full: "600 W 6th Street, Suite 400, Fort Worth, TX 76102",
  },
  phone: "817-308-0922",
  email: "torey@irvingrealestategroup.com",
  hours: "Mon-Sat 8am-7pm CST · Sun by appointment",
};

export const SOCIAL = {
  // Add handles when you create accounts; empty values are hidden in UI.
  instagram: "",
  facebook: "",
  linkedin: "",
  youtube: "",
  tiktok: "",
};

// TREC-required disclosures (Texas Real Estate Commission).
export const TREC = {
  iabsUrl: "https://www.trec.texas.gov/sites/default/files/pdf-forms/IABS%201-0.pdf",
  consumerProtectionUrl: "https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1_1.pdf",
};
